/* App skins (setting app_skins): style Growave's widgets inside their open shadow roots. */
(function () {
  'use strict';

  var FONT = '"Poppins",system-ui,-apple-system,"Segoe UI",sans-serif';
  // Each target: hosts whose open shadow root holds `probe`, the CSS to append there, and an optional page filter / callback.
  var TARGETS = [
    {
      hosts: '[class*="gw-widget-placeholder"], [class*="gw-widget-placeholder"] *',
      probe: '.gw-launcher',
      css:
        '.gw-launcher{background:#2a2b2a!important;border-radius:12px 12px 0 0!important;box-shadow:0 1px 2px rgba(9,3,2,.05),0 10px 26px -12px rgba(9,3,2,.18)!important;font-family:' + FONT + '!important}' +
        '.gw-launcher,.gw-launcher__text{color:#f2f0eb!important}' +
        '.gw-launcher__text{font-family:inherit!important;font-size:13px!important;font-weight:700!important;line-height:1!important;letter-spacing:.06em;text-transform:uppercase}' +
        '.gw-launcher:focus-visible{outline:2px solid #f2f0eb!important;outline-offset:-4px!important}',
      onStyled: function () {
        var root = document.documentElement;
        root.style.setProperty('--gw-wl-wishlistIconSettings-heartColor', '#f2f0eb');
        // lets app-skins.css add the buy-column gutter only where the launcher is shown (the header_wishlist_icon setting hides it)
        var wrapper = document.querySelector('.gw-widget-placeholder-RC-wrapper');
        if (!wrapper || getComputedStyle(wrapper).display !== 'none') root.classList.add('has-gw-launcher');
      }
    },
    {
      hosts: '.gw-wl-add-to-wishlist-placeholder, .gw-wl-add-to-wishlist-placeholder *',
      probe: '.gw-btn.gw-button',
      applies: function () { return document.body.classList.contains('template-product'); },
      css:
        '.gw-btn.gw-button{background:transparent!important;color:#2a2b2a!important;border:2px solid #2a2b2a!important;border-radius:28px!important;font-family:' + FONT + '!important;font-size:14px!important;font-weight:700!important;letter-spacing:0!important;box-shadow:none!important}' +
        '.gw-btn.gw-button:hover{background:#2a2b2a!important;color:#f2f0eb!important}' +
        '.gw-btn.gw-button:focus-visible{outline:2px solid #2a2b2a!important;outline-offset:2px!important}' +
        '.gw-btn.gw-button .gw-wl-icon,.gw-btn.gw-button .gw-badge{color:inherit!important}' +
        '.gw-btn.gw-button[data-in-wishlist="true"] .gw-wl-icon path{fill:#c0341d!important;stroke:#c0341d!important}' +
        // BG-392 follow-up, phones only (desktop keeps the pill above): a 44px outlined heart at the end of the buy row. The label stays in the
        // DOM, visually hidden, so the button is still named "Add to wishlist" / "Added to wishlist". With Growave's counter on, the count shows
        // as a badge; its alt text "" keeps it out of the name (the counter's hidden description still reads it). Hover is white, not ink: the
        // red in-wishlist heart on ink is only 2.5:1.
        '@media (max-width:768.98px){' +
          '.gw-wl-add-to-wishlist-product-page-widget{width:44px!important;overflow:visible!important}' +
          '.gw-btn.gw-button{position:relative!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;width:44px!important;min-width:44px!important;height:44px!important;min-height:44px!important;padding:0!important;border-radius:50%!important;overflow:visible!important}' +
          '.gw-btn.gw-button:hover{background:#fff!important;color:#2a2b2a!important}' +
          '.gw-wl-add-to-wishlist-btn__inner{gap:0!important;display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important}' +
          '.gw-wl-add-to-wishlist-btn__inner .gw-wl-icon{width:22px!important;height:22px!important;min-width:22px!important;flex:none!important}' +
          // the label (the only span that is not aria-hidden) stays as the accessible name, visually hidden
          '.gw-wl-add-to-wishlist-btn__inner>span:not([aria-hidden="true"]){position:absolute!important;width:1px!important;height:1px!important;margin:-1px!important;padding:0!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important;border:0!important}' +
          // the Growave count badge is aria-hidden, so the count stays out of the name; it is moved to the heart top-right corner
          '.gw-wl-add-to-wishlist-btn__inner>span[aria-hidden="true"]{position:absolute!important;top:-6px!important;right:-6px!important;display:block!important}' +
          '.gw-wl-add-to-wishlist-btn__inner>span[aria-hidden="true"] .gw-badge{box-sizing:border-box!important;display:block!important;min-width:20px!important;height:20px!important;padding:0 5px!important;border-radius:10px!important;background:#2a2b2a!important;color:#f2f0eb!important;font-family:' + FONT + '!important;font-size:11px!important;font-weight:700!important;line-height:20px!important;text-align:center!important}' +
          '.gw-wl-add-to-wishlist-btn__inner>span[aria-hidden="true"] .gw-badge *{color:#f2f0eb!important;font-size:11px!important;line-height:20px!important}' +
        '}'
    },
    {
      // BG-185: the My Wishlist page (/pages/wishlist). Growave's page widget is one open shadow root; its product cards load later but the injected CSS is class-based, so one injection covers them.
      hosts: '.gw-wl-page-placeholder',
      probe: '.gw-wl-v2',
      applies: function () { return /\/pages\/wishlist\/?$/.test(location.pathname); },
      css:
        '.gw-wl-v2{--gw-theme-main-text-primary:#2a2b2a!important;--gw-theme-accent-link-text:#2a2b2a!important;--gw-text-tertiary:#63605a!important;--gw-border-radius-500:12px!important;color:#2a2b2a;font-family:' + FONT + '}' +
        '.gw-wl-v2 h2.gw-text{font-family:' + FONT + '!important;font-weight:600!important;color:#2a2b2a!important}' +
        '.gw-wl-v2 .gw-btn--mode-link,.gw-wl-v2 .gw-select-btn,.gw-wl-share svg,.gw-wl-share a,.gw-wl-share button{color:#2a2b2a!important;font-family:' + FONT + '!important}' +
        '.gw-wl-v2 .gw-wl-share svg,.gw-wl-v2 .gw-wl-share svg path{fill:currentColor}' +
        '.gw-wl-v2 :is(button,a,[role=button],select):focus-visible{outline:2px solid #2a2b2a!important;outline-offset:2px!important}' +
        '.gw-wl-v2 .gw-empty-state{background:#fff!important;color:#2a2b2a!important;border-radius:12px!important;box-shadow:0 1px 2px rgba(9,3,2,.05),0 10px 26px -12px rgba(9,3,2,.18)}' +
        '.gw-wl-v2 .gw-empty-state .gw-text,.gw-wl-v2 .gw-empty-state .gw-wl-icon{color:#2a2b2a!important}' +
        '.gw-wl-product-card{background:#fff;border-radius:12px;overflow:hidden;box-shadow:0 1px 2px rgba(9,3,2,.05),0 10px 26px -12px rgba(9,3,2,.18)}' +
        '.gw-wl-product-card__image{border-radius:0!important}' +
        '.gw-wl-v2 .gw-wl-product-card__image-wrap :is(a,button):focus-visible{outline-offset:-4px!important}' +
        '.gw-wl-product-card__content{padding:0 12px 12px}' +
        '.gw-wl-product-card__title-link,.gw-wl-product-card__title-link .gw-text{color:#2a2b2a!important;font-family:' + FONT + '!important;font-weight:600!important}' +
        '.gw-wl-product-card__menu-btn{color:#2a2b2a!important}' +
        '.gw-price .gw-text--tone-base,.gw-price .gw-text--tone-success{color:#a82c17!important;font-weight:800!important}' +
        '.gw-price del,.gw-price del .gw-text{color:#63605a!important;font-weight:400!important;text-decoration:line-through}' +
        '.gw-wl-product-card__badges .gw-badge{background:#aa1155!important;color:#fff!important;border-radius:6px!important;padding:4px 8px!important;font-size:10.5px!important;font-weight:800!important;letter-spacing:.02em;box-shadow:0 1px 4px rgba(0,0,0,.2)}' +
        '.gw-wl-product-card__badges .gw-badge .gw-text{color:inherit!important;font-size:inherit!important;font-weight:inherit!important}'
    }
  ];

  var observers = [];
  var watched = new WeakSet();
  var timer = 0;
  var capped = false;

  function stopAll() {
    capped = true;
    clearTimeout(deadline);
    clearTimeout(timer);
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
  }

  function watch(node, opts) {
    var o = new MutationObserver(function (records) {
      // Only wake up for added nodes, then batch into one scan.
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) { schedule(); return; }
      }
    });
    o.observe(node, opts);
    observers.push(o);
  }

  function schedule() {
    if (capped || timer) return;
    timer = setTimeout(function () { timer = 0; run(); }, 100);
  }

  // Styles every applicable target that is ready (once per shadow root, so a root that replaces an old one after a section reload gets the
  // skin too); stops when every applicable target has a styled root.
  var styled = new WeakSet();
  function run() {
    var pending = 0;
    TARGETS.forEach(function (t) {
      if (t.applies && !t.applies()) return;
      var any = false;
      var hosts = document.querySelectorAll(t.hosts);
      for (var i = 0; i < hosts.length; i++) {
        var root = hosts[i].shadowRoot;
        if (!root) continue;
        if (root.querySelector(t.probe)) {
          any = true;
          if (styled.has(root)) continue;
          styled.add(root);
          if (!root.querySelector('style[data-app-skins]')) {
            var style = document.createElement('style');
            style.setAttribute('data-app-skins', '');
            style.textContent = t.css;
            root.appendChild(style);
          }
          if (t.onStyled) t.onStyled();
          continue;
        }
        // Host exists but its content renders later: watch the shadow root itself.
        if (!watched.has(root)) {
          watched.add(root);
          watch(root, { childList: true, subtree: true });
        }
      }
      if (!any) pending++;
    });
    if (!pending) stopAll();
  }

  // PDP: moves the Growave wishlist placeholder (from its own app block, or wherever Growave put it in the form) so Tab order matches what
  // is on screen (CSS `order` would not). Moving the host keeps its open shadow root; the emptied app block is hidden so its spacing goes too.
  // - 769px and up: after Notify Me (app-injected .nm-portal), which sits right under the buy row; right after the row if there is none.
  // - Up to 768.98px (BG-392 follow-up): right after .product-info__add-to-cart, where app-skins.css gives the heart its reserved 44px column.
  // shortcut: the section observer stays for the page's life so a late Growave move, a late or re-injected Notify Me and variant switches
  // (variant-picker.js swaps the row in place) are handled; it only calls the idempotent move().
  function orderBuyColumn() {
    if (!document.body.classList.contains('template-product')) return;
    var phone = window.matchMedia('(max-width: 768.98px)');
    function move() {
      var form = document.querySelector('.product-main .js-product-form-main');
      var row = form && form.querySelector(':scope > .product-info__add-to-cart');
      var wl = document.querySelector('.product-main .gw-wl-add-to-wishlist-placeholder');
      if (!row || !wl) return form;
      var nm = form.querySelector(':scope > .nm-portal');
      var anchor = phone.matches || !nm ? row : nm;
      if (anchor.nextElementSibling === wl) return form;
      var home = wl.closest('.product-info__block');
      anchor.after(wl);
      if (home && !home.contains(form)) home.hidden = true;
      return form;
    }
    // Watches the whole product section (not only the form's direct children): the placeholder can arrive late, inside its app block, or be
    // replaced. move() is idempotent (it returns early once the placeholder already follows its anchor), so its own DOM change does not loop;
    // Growave re-renders happen inside the shadow root, which this observer does not see.
    function watchForm() {
      var main = document.querySelector('.product-main');
      move();
      if (!main || main.hasAttribute('data-buy-row')) return;
      main.setAttribute('data-buy-row', '');
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].addedNodes.length || records[i].removedNodes.length) { move(); return; }
        }
      }).observe(main, { childList: true, subtree: true });
    }
    watchForm();
    phone.addEventListener('change', move);
    // theme editor: a section reload brings back the wishlist block (app-skins.css un-hides it after a few seconds if it is never moved)
    // and a new Growave shadow root, which needs the skin again.
    document.addEventListener('shopify:section:load', function () { watchForm(); rescan(); });
  }

  // One owned scan deadline: restarting discovery (start or section reload) cancels the old deadline and observers first.
  var deadline = 0;
  function rescan() {
    clearTimeout(deadline);
    clearTimeout(timer);
    timer = 0;
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
    watched = new WeakSet();
    capped = false;
    watch(document.body, { childList: true, subtree: true });
    deadline = setTimeout(stopAll, 15000);
    run();
  }

  function start() {
    orderBuyColumn();
    rescan();
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
